import { useEffect, useState } from "react";
import "./ExcluirOrigemCarregamentoTrilhosNovosModal.css";

export default function ExcluirOrigemCarregamentoTrilhosNovosModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao excluir.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocnex-bg" onClick={onClose}>
      <div className="ocnex-box" role="dialog" aria-modal="true" aria-label="Excluir origem novos" onClick={(e) => e.stopPropagation()}>
        <header className="ocnex-head">
          <h3 className="ocnex-title">Excluir</h3>
          <button className="ocnex-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="ocnex-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "esta origem"}"?
          <div className="ocnex-warn">Esta acao nao pode ser desfeita.</div>
          {err ? <div className="ocnex-err">{err}</div> : null}
        </div>
        <footer className="ocnex-foot">
          <button className="ocnex-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ocnex-btn ocnex-btn-danger" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </footer>
      </div>
    </div>
  );
}

